module.exports = __webpack_public_path__ + "static/media/route.3a1e32b7.svg";